import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { notificationSuccess } from '../Redux/NotificationActions'

import NotificationsActions, { NotificationsRedux, NotificationsTypes } from '../Redux/NotificationsRedux'
import ClassroomActions from '../Redux/ClassroomRedux'

const notificationsCRUDObservable = createCRUDObservable({
  mainRedux: NotificationsRedux,
  reduxPath: 'notifications_types',
})

const configNotificationsEpic = (action$, store, { Api }) =>
  action$.ofType(NotificationsTypes.updateNotificationsRequest)
    .mergeMap(({ studentId, activeNotifications }) => (
      Observable
        .fromPromise(Api.notifications_types.updateNotifications(studentId, activeNotifications)
          .then(response => response)
          .catch(err => err))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [NotificationsActions.updateNotificationsError(result.error)]
          }
          const { active_notifications: actNot } = activeNotifications
          const notifications_types = store.getState().notifications_types.get.results
          const disabled_notifications_objects = notifications_types
            .filter(type => actNot.indexOf(type.id) < 0)
          const disabled_notifications = disabled_notifications_objects
            .map(notification => notification.id)
          return [
            NotificationsActions.updateNotificationsSuccess(activeNotifications),
            notificationSuccess('Notificaciones Actualizadas'),
            ClassroomActions.updateNotificationsStudent(disabled_notifications),
          ]
        })
    ))

const configParentNotificationsEpic = (action$, store, { Api }) =>
  action$.ofType(NotificationsTypes.updateParentNotificationsRequest)
    .mergeMap(({ studentId, activeNotifications }) => (
      Observable
        .fromPromise(Api.notifications_types.updateParentNotifications(studentId, activeNotifications)
          .then(response => response)
          .catch(err => err))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [NotificationsActions.updateParentNotificationsError(result.error)]
          }
          return [
            NotificationsActions.updateParentNotificationsSuccess(activeNotifications),
            notificationSuccess('Notificaciones Actualizadas'),
          ]
        })
    ))

export const notificationsObservers = Object.assign({}, notificationsCRUDObservable.observers, {})


export const notificationsEpic = combineEpics(
  notificationsCRUDObservable.epic,
  configNotificationsEpic,
  configParentNotificationsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/NotificationsObservable.js